// extracted by mini-css-extract-plugin
module.exports = {"form":"StoreForm_form__arcP5"};